import { instruments } from "../instruments.js";
function collectFormData(form) {
    const formData = {};
    const experimentsDiv = form.document.querySelector(`#${form.id}`);
    const activeTab = experimentsDiv.querySelector('.tab-content.active');
    const instrumentId = activeTab?.dataset.instrument;
    if (!instrumentId)
        return formData;
    formData.instrument = instrumentId;
    formData.experiments = [];
    const experiments = activeTab.querySelectorAll('.experiment-item');
    for (const exp of experiments) {
        const checkbox = exp.querySelector('.experiment-toggle');
        const experimentData = {
            name: checkbox.dataset.experiment,
            enabled: checkbox.checked,
            parameters: {},
        };
        for (const input of exp.querySelectorAll('.parameter-input')) {
            experimentData.parameters[input.dataset.label] = input.value;
        }
        formData.experiments.push(experimentData);
    }
    return formData;
}
function createExperimentElement(document, experiment) {
    const div = document.createElement('div');
    div.className = 'experiment-item';
    const header = document.createElement('div');
    header.className = 'experiment-header';
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.className = 'experiment-toggle';
    checkbox.dataset.experiment = experiment.experiment;
    checkbox.checked = experiment.enabled || false;
    const label = document.createElement('label');
    label.textContent = experiment.experiment;
    label.style.cursor = 'pointer';
    header.append(checkbox);
    header.append(label);
    const paramsDiv = document.createElement('div');
    paramsDiv.className = 'experiment-parameters';
    paramsDiv.style.display = experiment.enabled || false ? 'block' : 'none';
    for (const param of experiment.parameters) {
        const paramDiv = document.createElement('div');
        paramDiv.className = 'parameter-item';
        const paramLabel = document.createElement('label');
        paramLabel.textContent = param.label;
        const input = document.createElement('input');
        input.type = 'text';
        input.className = 'parameter-input';
        input.dataset.label = param.label;
        input.value = param.value;
        paramDiv.append(paramLabel);
        paramDiv.append(input);
        paramsDiv.append(paramDiv);
    }
    div.append(header);
    div.append(paramsDiv);
    return div;
}
function createTabContent(form, instrumentId, instrumentData) {
    const content = form.document.createElement('div');
    content.className = 'tab-content';
    content.dataset.instrument = instrumentId;
    for (const experiment of instrumentData.experiments) {
        content.append(createExperimentElement(form.document, experiment));
    }
    return content;
}
function switchTab(form, instrumentId) {
    const experimentsDiv = form.document.querySelector(`#${form.id}`);
    for (const tab of experimentsDiv.querySelectorAll('.tab')) {
        tab.classList.toggle('active', tab.dataset.instrument === instrumentId);
    }
    for (const content of experimentsDiv.querySelectorAll('.tab-content')) {
        content.classList.toggle('active', content.dataset.instrument === instrumentId);
    }
    form.onFormChange(collectFormData(form));
}
export function fillForm(form) {
    const experimentsDiv = form.document.querySelector(`#${form.id}`);
    const tabsContainer = experimentsDiv.querySelector('#tabs');
    const formContainer = experimentsDiv.querySelector('#form-container');
    // Clear existing content
    tabsContainer.innerHTML = '';
    formContainer.innerHTML = '';
    const instrumentIds = Object.keys(instruments);
    for (const [index, instrumentId] of instrumentIds.entries()) {
        const tab = form.document.createElement('button');
        tab.className = 'tab';
        tab.dataset.instrument = instrumentId;
        tab.textContent = instrumentId;
        if (index === 0)
            tab.classList.add('active');
        tabsContainer.append(tab);
        const content = createTabContent(form, instrumentId, instruments[instrumentId]);
        if (index === 0)
            content.classList.add('active');
        formContainer.append(content);
    }
    // Event delegation at experiments div level
    experimentsDiv.addEventListener('click', (e) => {
        if (e.target.classList.contains('tab')) {
            switchTab(form, e.target.dataset.instrument);
        }
        else if (e.target.classList.contains('experiment-header') ||
            e.target.closest('.experiment-header label')) {
            const checkbox = e.currentTarget
                .querySelector('.experiment-item')
                ?.querySelector('.experiment-toggle');
            if (checkbox &&
                (e.target.tagName === 'LABEL' || e.target.closest('.experiment-header'))) {
                const experimentItem = e.target.closest('.experiment-item');
                if (experimentItem) {
                    const checkboxInItem = experimentItem.querySelector('.experiment-toggle');
                    if (checkboxInItem) {
                        checkboxInItem.click();
                    }
                }
            }
        }
    });
    experimentsDiv.addEventListener('change', (e) => {
        if (e.target.classList.contains('experiment-toggle')) {
            const experimentItem = e.target.closest('.experiment-item');
            const params = experimentItem.querySelector('.experiment-parameters');
            params.style.display = e.target.checked ? 'block' : 'none';
            form.onFormChange(collectFormData(form));
        }
    });
    experimentsDiv.addEventListener('input', (e) => {
        if (e.target.classList.contains('parameter-input')) {
            form.onFormChange(collectFormData(form));
        }
    });
}
//# sourceMappingURL=fillForm.js.map